
import {
  Vue,
  Component,
  Mixins,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { Pagination } from 'element-ui';
import { State, Mutation } from 'vuex-class';
import { ITABLECOLCONF, IPAGE } from '@/types/base.d';
import api from '@/api/org';
import pageMixin from '@/views/Home/mixins/pageMixin';
import { ChargeTypeEnum } from '@/libs/config';
import { ICharge } from '@/types/org.d';
import RechargeModal from '../form/recharge/index.vue';

@Component({
  components: {
    Pagination,
    RechargeModal,
  },
})
export default class Account extends Mixins(pageMixin) {
  @State(state => state.org.curCompRefresh) curCompRefresh!: boolean;

  @Mutation('org/SET_ORG_COMPENT_REFRESH') handleCloseRerfesh!: Function;

  @Mutation('org/SET_ORG_INFO_STATUS') handleRefreshInfo!: Function;

  @Mutation('org/SET_ORG_COST_STATUS') handleRefreshCost!: Function;

  @Mutation('org/SET_ORG_CONSUME_STATUS') handleRefreshConsume!: Function;

  private loading: Boolean = true;

  private isExpand: Boolean = true;

  private tList: Array<any> = [];

  private orgId: string = '';

  private title: string = '';

  private visible: boolean = false;

  private form: ICharge = {
    money: 500,
    payType: 0,
    orgPid: '',
  }

  @Prop({
    required: true,
  }) chargeType!: string;

  private column: Array<ITABLECOLCONF> = [];

  private rechargeConf: Array<ITABLECOLCONF> = [
    {
      label: '流水号',
      prop: 'walletSn',
      align: 'center',
      width: '120px',
    },
    {
      label: '充值金额',
      align: 'center',
      prop: 'money',
      width: '130px',
    },
    {
      label: '充值类型',
      align: 'center',
      width: '160px',
      prop: 'payType',
      formatter: (row: any) => ChargeTypeEnum[row.payType],
    },
    {
      label: '创建时间',
      align: 'center',
      prop: 'createTime',
      width: '160px',
    },
    {
      label: '备注',
      prop: 'remark',
      align: 'center',
      minWidth: '50px',
      tooltip: true,
      headerAlign: 'center',
      formatter: (row: any) => {
        if (row.payType === 5) return '课程服务费退还';
        return row.remark;
      },
    },
    {
      label: '操作',
      custom: true,
      minWidth: '80',
      align: 'center',
      maxBtn: 1,
      btnList: [
        {
          title: '编辑',
          name: '/org/manage:generateCode',
          icon: 'edit',
          type: 'info',
          callback: this.handleRecharge,
          handleDis: (row: any) => row.payType === 5,
          log: {
            name: '机构信息 - 账户明细 - 充值明细 - 编辑',
            component: '/org/operate/account:update',
          },
        },
      ],
    },
  ];

  private consumeConf: Array<ITABLECOLCONF> = [
    {
      label: '流水号',
      prop: 'walletSn',
      align: 'center',
      tooltip: true,
    },
    {
      label: '姓名',
      align: 'center',
      prop: 'csrName',
    },
    {
      label: '金额',
      align: 'center',
      prop: 'money',
    },
    {
      label: '关联账号',
      align: 'center',
      prop: 'userTitle',
      tooltip: true,
      minWidth: '80px',
    },
    {
      label: '课包',
      align: 'center',
      prop: 'courseTitle',
      tooltip: true,
      minWidth: '150px',
    },
    {
      label: '版本号',
      align: 'center',
      prop: 'courseVersion',
      tooltip: true,
      minWidth: '100px',
    },
    {
      label: '创建时间',
      align: 'center',
      prop: 'createTime',
      minWidth: '100px',
      tooltip: true,
    },
    {
      label: '操作',
      custom: true,
      minWidth: '80',
      align: 'center',
      maxBtn: 1,
      btnList: [
        {
          title: '退费',
          name: '/org/operate/account:refund',
          icon: 'ticket',
          type: 'warning',
          callback: this.handleRefund,
          log: {
            name: '机构信息 - 账户明细 - 消费明细 - 退费',
            component: 'org/operate/table/account',
          },
          handleDis: (row: any) => row.status !== 1,
        },
      ],
    },
  ];

  private expandObj: any = {};

  mounted() {
    if (this.curCompRefresh) this.handlePageRefrsh(true);
  }

  handleRecharge(row: any) {
    this.form = {
      money: row.money,
      payType: row.payType,
      orgPid: row.orgPid,
      remark: row.remark,
      pid: row.pid,
    };
    if (row.payType === 6) this.title = '编辑对充';
    else this.title = '编辑充值';
    this.visible = true;
  }

  /**
   * @author Terry
   * @description 获取充值明细
   */
  getRechargeData() {
    this.loading = true;
    api.getOrgAccountRecharge(this.page, this.orgId).then((res: any) => {
      this.tList = res.content;
      this.total = res.totalElements;
      this.loading = false;
    });
  }

  /**
   * @author Terry
   * @description 获取消费明细
   */
  getConsumeData() {
    this.loading = true;
    api.getOrgAccountConsume(this.page, this.orgId).then((res: any) => {
      this.tList = res.content;
      this.total = res.totalElements;
      this.loading = false;
    });
  }

  getData() {
    this.orgId = this.$route.params.pid || '';
    if (this.chargeType.includes('充值')) {
      this.column = this.rechargeConf;
      this.isExpand = true;
      this.getRechargeData();
    } else {
      this.column = this.consumeConf;
      this.isExpand = false;
      this.getConsumeData();
    }
  }

  handleExpand(row: any) {
    if (row.payType === 5) {
      api.getRefundInfo({ walletPid: Base64.encode(row.pid) }).then((res: any) => {
        this.tList.forEach((em:any, index: number) => {
          if (em.pid === row.pid) {
            Vue.set(this.tList[index], 'csrName', res[0].csrName);
            Vue.set(this.tList[index], 'userTitle', res[0].userTitle);
            Vue.set(this.tList[index], 'money', res[0].money);
            Vue.set(this.tList[index], 'courseTitle', `${res[0].courseTitle} ${res[0].courseVersion}`);
          }
        });
      });
    }
  }

  /**
   * @author Terry
   * @description 服务费退还
   * @param { any } row 行数据
   */
  handleRefund(row: any) {
    this.confirm('你确认进行该操作吗?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.refund({ consumePid: Base64.encode(row.pid) }).then(() => {
        close();
        this.getData();
        this.handleRefreshInfo(true);
        this.handleRefreshCost(true);
        this.handleRefreshConsume(true);
        this.$log({
          title: '机构管理 - 退费 - 确定',
          component: 'org/manage/account',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '机构管理 - 退费 - 取消',
      component: 'org/manage/account',
    }));
  }

  @Watch('chargeType', { immediate: true })
  handleToggleType(v: string) {
    this.page.pageNo = 1;
    this.getData();
  }

  @Watch('curCompRefresh')
  handlePageRefrsh(v: boolean) {
    if (v) {
      this.handleCloseRerfesh(false);
      this.page.pageNo = 1;
      if (this.chargeType.includes('充值')) this.getRechargeData();
      else this.$emit('changeChargeType', '充值明细');
    }
  }

  @Watch('page', { immediate: false, deep: true })
  handlePageChange() {
    this.getData();
  }
}
